import { schema, types } from 'papr'

export const userReactionSchema = schema(
	{
		user: types.objectId(), // Person who reacted
		post: types.objectId(),
		response: types.objectId(),
		reply: types.objectId(),
		reactionType: types.string(), // mark as enum
		reaction: types.objectId(),
		reactionCount: types.number(),
		tags: types.array(types.objectId()),
		author: types.objectId(), // Post author
		dateAdded: types.date(),
	},
	{
		defaults: {
			reactionCount: 1,
		},
	},
)

export type UserReactionDocument = (typeof userReactionSchema)[0]
export type UserReactionDefaults = (typeof userReactionSchema)[1]
